// Topic emoji mapping for fallbacks when API doesn't provide icons
export const TOPIC_EMOJIS: Record<string, string> = {
  // Primary hubs (from categories)
  biology: '🧬',
  chemistry: '🧪',
  'computer-science': '💻',
  physics: '⚛️',
  economics: '📈',
  medicine: '🏥',
  mathematics: '🔢',
  engineering: '⚙️',
  astrophysics: '🌌',
  'social-sciences': '👥',
  'nonlinear-sciences': '∞',
  biochemistry: '🧫',
  statistics: '📊',
  bioengineering: '🔬',
  electrochemistry: '🔋',
  // Biology hubs
  paleontology: '🦖',
  pathology: '🔬',
  'evolutionary-biology': '🧬',
  neuroscience: '🧠',
  bioinformatics: '💻',
  'systems-biology': '🔗',
  genomics: '🧬',
  zoology: '🦁',
  'synthetic-biology': '🧪',
  'developmental-biology': '🌱',
  ecology: '🌿',
  pharmacology: '💊',
  'cell-biology': '🦠',
  biophysics: '⚛️',
  'molecular-biology': '🧬',
  physiology: '❤️',
  microbiology: '🦠',
  'cancer-biology': '🎗️',
  'plant-biology': '🌱',
  'genetics-and-genomics': '🧬',
  'biological-physics': '🔬',
  'quantitative-biology': '📊',
  biomolecules: '🧪',
  'molecular-networks': '🔗',
  'other-quantitative-biology': '📈',
  'populations-and-evolution': '🌍',
  'quantitative-methods': '📊',
  'subcellular-processes': '🔬',
  'tissues-and-organs': '🫀',
  immunology: '🛡️',
  // Chemistry hubs
  'organic-chemistry': '🧪',
  'computational-chemistry': '💻',
  'physical-chemistry': '⚛️',
  'materials-science': '🔧',
  'chemical-physics': '⚛️',
  'environmental-chemistry': '🌿',
  'chemical-engineering': '⚙️',
  'nuclear-chemistry': '☢️',
  'chemical-biology': '🧬',
  'supramolecular-chemistry': '🔗',
  catalysis: '⚡',
  'inorganic-chemistry': '🧪',
  'materials-chemistry': '🧱',
  astrochemistry: '🌌',
  'chemical-education': '📚',
  'food-chemistry': '🍽️',
  geochemistry: '🌍',
  'medicinal-chemistry': '💊',
  nanochemistry: '🔬',
  'organometallic-chemistry': '⚛️',
  'surface-chemistry': '🧲',
  'analytical-chemistry': '🔍',
  'analytical-biochemistry': '🔬',
  // Computer Science hubs
  'machine-learning': '🤖',
  'software-engineering': '💻',
  'computer-vision': '👁️',
  graphics: '🎨',
  'information-retrieval': '🔍',
  'human-computer-interaction': '👤',
  'distributed-computing': '🌐',
  'natural-language-processing': '🗣️',
  'game-theory': '🎮',
  'discrete-mathematics': '🔢',
  multimedia: '📹',
  'artificial-intelligence': '🤖',
  'computational-complexity': '🧩',
  'computational-geometry': '📐',
  'cryptography-and-security': '🔐',
  'data-structures-and-algorithms': '🔤',
  databases: '🗄️',
  'formal-languages': '📝',
  'hardware-architecture': '🖥️',
  'neural-computing': '🧠',
  networking: '🌐',
  'operating-systems': '⚙️',
  'programming-languages': '💻',
  sound: '🎵',
  'quantum-computing': '⚛️',
  'computational-engineering': '⚙️',
  'computers-and-society': '👥',
  'digital-libraries': '📚',
  'emerging-technologies': '🚀',
  'general-literature': '📖',
  'multiagent-systems': '🤝',
  'mathematical-software': '🔢',
  other: '📦',
  performance: '⚡',
  'symbolic-computation': '🔣',
  'social-networks': '🌐',
  'numerical-analysis': '🔢',
  logic: '🧩',
  robotics: '🤖',
  'information-theory': '📡',
  // Physics hubs
  'atomic-physics': '⚛️',
  optics: '🔦',
  'computational-physics': '💻',
  'statistical-mechanics': '📊',
  'fluid-dynamics': '💧',
  superconductivity: '🧲',
  'soft-matter': '🫧',
  'general-relativity': '🌌',
  geophysics: '🌍',
  'mathematical-physics': '📐',
  instrumentation: '🔧',
  cosmology: '🌌',
  'condensed-matter': '❄️',
  'high-energy-experiment': '⚡',
  'high-energy-phenomenology': '🌟',
  'high-energy-theory': '💫',
  'lattice-physics': '🔷',
  'nuclear-experiment': '☢️',
  'nuclear-theory': '⚛️',
  'plasma-physics': '🔥',
  'quantum-physics': '⚛️',
  'disordered-systems': '🌀',
  'mesoscale-physics': '🔬',
  'other-condensed-matter': '❄️',
  'quantum-gases': '💨',
  'strongly-correlated': '🔗',
  'general-physics': '🔭',
  'accelerator-physics': '🚀',
  'atmospheric-physics': '🌤️',
  'applied-physics': '⚙️',
  'atomic-clusters': '⚛️',
  'classical-physics': '🎱',
  'physics-education': '📚',
  'history-of-physics': '📜',
  'popular-physics': '🌟',
  'space-physics': '🚀',
  'data-analysis': '📊',
  // Economics hubs
  econometrics: '📊',
  'financial-economics': '💰',
  'computational-finance': '💻',
  'economic-theory': '📈',
  'general-economics': '💼',
  'general-finance': '💵',
  'mathematical-finance': '📐',
  'portfolio-management': '📊',
  'quantitative-finance': '📈',
  'risk-management': '⚠️',
  'securities-pricing': '💹',
  'statistical-finance': '📊',
  'trading-and-market-microstructure': '📈',
  // Medicine hubs
  'internal-medicine': '🏥',
  endocrinology: '💉',
  pediatrics: '👶',
  psychiatry: '🧠',
  radiology: '📷',
  'medical-physics': '⚛️',
  'public-health': '🏥',
  'physical-therapy': '🏃',
  nursing: '👩‍⚕️',
  cardiology: '❤️',
  dentistry: '🦷',
  'medical-education': '📚',
  ophthalmology: '👁️',
  'health-informatics': '💻',
  gastroenterology: '🔬',
  dermatology: '🧴',
  urology: '🏥',
  'obstetrics-and-gynecology': '👶',
  neurology: '🧠',
  nephrology: '🏥',
  hematology: '🩸',
  'pain-medicine': '💊',
  oncology: '🎗️',
  'emergency-medicine': '🚑',
  rheumatology: '🦴',
  'clinical-trials': '🧪',
  'critical-care-medicine': '🚨',
  'health-economics': '💰',
  'health-policy': '📋',
  'medical-ethics': '⚖️',
  nutrition: '🥗',
  'reproductive-health': '👶',
  'sports-medicine': '🏃',
  epidemiology: '📊',
  anesthesiology: '💉',
  'infectious-disease': '🦠',
  orthopedics: '🦴',
  otolaryngology: '👂',
  'palliative-medicine': '🤲',
  pulmonology: '🫁',
  surgery: '🏥',
  // Mathematics hubs
  combinatorics: '🔢',
  'algebraic-geometry': '📐',
  'algebraic-topology': '🔷',
  'analysis-of-pdes': '∂',
  'category-theory': '🔗',
  'classical-analysis': '📊',
  'commutative-algebra': '🔢',
  'complex-variables': '🌀',
  'differential-geometry': '📐',
  'dynamical-systems': '🔄',
  'functional-analysis': '📈',
  'general-mathematics': '🔢',
  'general-topology': '🔷',
  'geometric-topology': '📐',
  'group-theory': '🔗',
  'history-and-overview': '📚',
  'k-theory': '🎯',
  'metric-geometry': '📏',
  'number-theory': '🔢',
  'operator-algebras': '🔤',
  'optimization-and-control': '🎯',
  probability: '🎲',
  'quantum-algebra': '⚛️',
  'representation-theory': '🔷',
  'rings-and-algebras': '⭕',
  'spectral-theory': '🌈',
  'symplectic-geometry': '🔄',
  // Engineering hubs
  'signal-processing': '📡',
  'audio-and-speech-processing': '🎤',
  'image-and-video-processing': '📷',
  'systems-and-control': '⚙️',
  // Astrophysics hubs
  'planetary-science': '🪐',
  galaxies: '🌌',
  'high-energy-astrophysics': '💫',
  'solar-and-stellar': '☀️',
  // Social Sciences hubs
  'physics-and-society': '👥',
  'scientific-communication-and-education': '📚',
  // Nonlinear Sciences hubs
  'adaptation-and-self-organization': '🔄',
  'chaotic-dynamics': '🌀',
  'cellular-automata': '🔲',
  'pattern-formation': '🔷',
  'exactly-solvable-systems': '✓',
  // Statistics hubs
  applications: '📊',
  methodology: '📈',
  'statistics-theory': '📐',
  'general-statistics': '📊',
  computation: '💻',
  miscellaneous: '📦',
};

/**
 * Get the emoji for a topic based on its name or slug
 * @param topicName - The name or slug of the topic
 * @returns The emoji string or null if not found
 */
export function getTopicEmoji(topicName: string): string | null {
  if (!topicName) return null;

  // Convert to lowercase and replace spaces with hyphens to match our mapping keys
  const normalizedName = topicName.toLowerCase().replace(/\s+/g, '-');

  return TOPIC_EMOJIS[normalizedName] || null;
}
